import { useRouter } from 'next/router';
import { buildLoginHref } from '@lib/auth0/login-url';

/**
 * Login link for the page the user is currently on, so they come back to it
 * after signing in (FFH-2135). Pass an explicit `returnTo` where the page
 * knows the destination up front: `router.asPath` still holds the route
 * placeholder (`/[slug]`) while the page is server-rendered, so an explicit
 * value keeps the returnTo in the markup rather than waiting for hydration.
 */
export const useLoginHref = (
  returnTo?: string,
  parameters?: Record<string, string>
) => {
  const router = useRouter();
  return buildLoginHref(returnTo ?? router.asPath, parameters);
};

export default useLoginHref;
